import React from 'react';

const SvgHopCash = ({ title, ...props }) => (
  <svg width={83.417} height={63.343} {...props}>
    {title ? <title>{title}</title> : null}
    <g data-name="Group 910">
      <g data-name="Group 641" transform="rotate(-14.98 71.146 1.8)">
        <g data-name="Group 639">
          <path
            data-name="Path 917"
            d="M1.073 0A1.069 1.069 0 000 1.069l.019 27.94a1.065 1.065 0 001.065 1.063l61.739.076a1.06 1.06 0 001.063-1.06l-.018-27.941A1.076 1.076 0 0062.793.075z"
            fill="#1e4a22"
            stroke="#1e4a22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.189}
          />
          <path
            data-name="Path 918"
            d="M63.035 20.993a9.186 9.186 0 00-8.331 8.3l-45.5-.056a9.229 9.229 0 00-8.341-8.32L.852 9.155a9.186 9.186 0 008.33-8.3l45.5.056a9.231 9.231 0 008.342 8.321z"
            fill="#9ec446"
          />
        </g>
        <ellipse
          data-name="Ellipse 111"
          cx={9.758}
          cy={12.737}
          rx={9.758}
          ry={12.737}
          transform="rotate(-.193 946.47 -7432.325)"
          fill="#2e5527"
        />
        <g data-name="Group 640">
          <path
            data-name="Path 919"
            d="M33.796 25.492v-2.287a7.933 7.933 0 01-3.833-1.042l.637-2.216a7.465 7.465 0 003.689 1.042c1.489 0 2.505-.727 2.505-1.86 0-1.06-.828-1.745-2.579-2.383-2.483-.9-4.092-2.034-4.093-4.226 0-2.027 1.415-3.582 3.8-4V6.21l1.941-.004v2.2a7.593 7.593 0 013.264.782l-.636 2.163a7.055 7.055 0 00-3.216-.805c-1.655 0-2.246.846-2.245 1.647 0 .967.852 1.51 2.862 2.314 2.649.994 3.832 2.268 3.834 4.367 0 2-1.393 3.77-3.993 4.191v2.429z"
            fill="#9ec446"
          />
        </g>
      </g>
      <g data-name="Group 642" transform="rotate(-14.98 128.44 -29.29)">
        <g data-name="Group 639">
          <path
            data-name="Path 917"
            d="M1.073 0A1.069 1.069 0 000 1.069l.019 27.94a1.065 1.065 0 001.065 1.063l61.739.076a1.06 1.06 0 001.063-1.06l-.018-27.941A1.076 1.076 0 0062.793.075z"
            fill="#1e4a22"
            stroke="#1e4a22"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.189}
          />
          <path
            data-name="Path 918"
            d="M63.035 20.993a9.186 9.186 0 00-8.331 8.3l-45.5-.056a9.229 9.229 0 00-8.341-8.32L.852 9.155a9.186 9.186 0 008.33-8.3l45.5.056a9.231 9.231 0 008.342 8.321z"
            fill="#9ec446"
          />
        </g>
        <ellipse
          data-name="Ellipse 111"
          cx={9.758}
          cy={12.737}
          rx={9.758}
          ry={12.737}
          transform="rotate(-.193 714.651 -6572.386)"
          fill="#2e5527"
        />
        <g data-name="Group 640">
          <path
            data-name="Path 919"
            d="M30.898 24.716v-2.287a7.933 7.933 0 01-3.833-1.042l.637-2.216a7.465 7.465 0 003.689 1.042c1.489 0 2.505-.727 2.505-1.86 0-1.06-.828-1.745-2.579-2.383-2.483-.9-4.092-2.034-4.093-4.226 0-2.027 1.415-3.582 3.8-4v-2.31l1.941-.004v2.2a7.593 7.593 0 013.264.782l-.636 2.163a7.055 7.055 0 00-3.216-.805c-1.655 0-2.246.846-2.245 1.647 0 .967.852 1.51 2.862 2.314 2.649.994 3.832 2.268 3.834 4.367 0 2-1.393 3.77-3.993 4.191v2.429z"
            fill="#9ec446"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgHopCash;
